import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';
import { filter, switchMap } from 'rxjs/operators';
import { RoutesEnum } from '@app/core/utils';
import { map, Observable } from 'rxjs';

export const REDIRECT_AFTER_LOGIN_KEY = 'redirectAfterLogin';

export function notAuthenticatedUserRouteGuard(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<true | UrlTree> {
    const router = inject(Router);
    const authenticationService = inject(AuthenticationService);

    return authenticationService.identityFetching$.pipe(
        filter((fetching) => !fetching),
        switchMap(() => authenticationService.identity$),
        map((identity) => {
            if (!identity) {
                if (state.url && state.url !== '/') {
                    sessionStorage.setItem(REDIRECT_AFTER_LOGIN_KEY, state.url);
                }
                return router.createUrlTree([RoutesEnum.ROOT]);
            }

            return true;
        }),
    );
}
